var React = require('react');

function Right (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.66618 10H16.3329","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.4995 4.16667L16.3328 10L10.4995 15.8333","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Right.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = Right;

Right.default = Right;
